import { SVGProps } from 'react'

export const PickleBall = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <g fill="currentColor" clipPath="url(#clip0_200_5709)">
      <path d="M18.5 18c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5-1.5-.7-1.5-1.5.7-1.5 1.5-1.5zm0-2c-1.9 0-3.5 1.6-3.5 3.5s1.6 3.5 3.5 3.5 3.5-1.6 3.5-3.5-1.6-3.5-3.5-3.5zM13.1 3.1c.9 0 1.7.3 2.3 1l1.5 1.5c.6.6 1 1.4 1 2.3 0 .9-.3 1.7-1 2.3l-3.1 3.1c-.8.8-1.9 1.3-3.1 1.3-1.2 0-2.3-.5-3.1-1.3-1.7-1.7-1.7-4.5 0-6.2L10.7 4c.6-.5 1.5-.9 2.4-.9zm0-2.1c-1.4 0-2.8.5-3.8 1.6l-3.1 3c-2.5 2.5-2.5 6.7 0 9.2 1.3 1.3 2.9 1.9 4.6 1.9 1.7 0 3.3-.6 4.6-1.9l3.1-3.1c2.1-2.1 2.1-5.6 0-7.7L17 2.5c-1.2-1-2.6-1.5-3.9-1.5z"></path>
      <path d="M6.9 14.1c.4.4.4 1.1 0 1.5l-3.1 3.1c-.4.4-1.1.4-1.5 0-.4-.4-.4-1.1 0-1.5l3.1-3.1c.4-.4 1.1-.4 1.5 0z"></path>
    </g>
    <defs>
      <clipPath id="clip0_200_5709">
        <path fill="currentColor" d="M0 0H24V24H0z"></path>
      </clipPath>
    </defs>
  </svg>
)
